import * as yup from 'yup';
import {ERROR_MESSAGE, STORY_DESCRIPTION_MIN_LENGTH, STORY_TITLE_MAX_LENGTH} from 'utils';

export const schema = yup.object({
    tags: yup.array().min(1, ERROR_MESSAGE.REQUIRED_EMPTY).required(ERROR_MESSAGE.REQUIRED_EMPTY),
    title: yup.string().max(STORY_TITLE_MAX_LENGTH, ERROR_MESSAGE.REQUIRED_EMPTY).required(ERROR_MESSAGE.REQUIRED_EMPTY),
    description: yup
        .string()
        .test('min-length', ERROR_MESSAGE.REQUIRED_EMPTY, (value) => !!value && value.trim().length >= STORY_DESCRIPTION_MIN_LENGTH)
        .required(ERROR_MESSAGE.REQUIRED_EMPTY),
    photo: yup.mixed().required(ERROR_MESSAGE.REQUIRED_EMPTY)
});
